module.exports = __webpack_public_path__ + "img/yearIndex-title.ac8325ca.png";